import type { RouteLocationNormalizedLoaded } from '#vue-router'

export default (route?: RouteLocationNormalizedLoaded) => {
  if (route == null) route = useRoute()
  const bn = useRouteBaseName()

  return bn(route) ?? route.name?.toString() ?? 'unknown'
}
